<template>
  <div
    class="dashboard-skeleton"
    role="status"
    aria-live="polite"
    aria-label="Loading dashboard"
  >
    <v-container style="max-width: 1280px;" class="pt-6 pb-0">
      <v-skeleton-loader type="heading" class="dashboard-skeleton__greeting mb-2" />
      <v-skeleton-loader type="text" width="220" />
    </v-container>

    <v-container style="max-width: 1280px;" class="py-4">
      <v-skeleton-loader type="image" height="88" class="rounded-lg" />
    </v-container>

    <v-container style="max-width: 1280px;" class="mt-2 pt-2 pb-4">
      <v-row class="py-2" style="margin: 0 -8px;">
        <v-col
          v-for="n in 6"
          :key="'stat-' + n"
          cols="6"
          sm="4"
          md="2"
          style="padding: 8px;"
        >
          <v-skeleton-loader
            type="image"
            height="128"
            class="rounded-lg dashboard-skeleton__stat"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-container style="max-width: 1280px;">
      <v-row style="margin: 0 -12px;">
        <v-col cols="12" lg="8" style="padding: 0 12px;">
          <div class="d-flex flex-wrap mb-4" style="gap: 8px;">
            <v-skeleton-loader
              v-for="n in 5"
              :key="'tab-' + n"
              type="chip"
              width="100"
            />
          </div>

          <v-skeleton-loader
            v-for="n in 3"
            :key="'section-' + n"
            type="article"
            class="dashboard-skeleton__section mb-4 rounded-lg"
          />
        </v-col>

        <v-col cols="12" lg="4" style="padding: 0 12px;">
          <v-skeleton-loader
            type="image"
            height="200"
            class="rounded-lg mb-4"
          />
          <v-skeleton-loader
            type="list-item-three-line"
            v-for="n in 3"
            :key="'side-' + n"
            class="mb-2"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "DashboardSkeleton",
};
</script>

<style scoped>
.dashboard-skeleton {
  background-color: #ffffff;
}

.dashboard-skeleton__greeting >>> .v-skeleton-loader__bone {
  max-width: 320px;
}

.dashboard-skeleton__stat >>> .v-skeleton-loader__image {
  border: 1px solid #e5e7eb;
}

.dashboard-skeleton__section {
  border: 1px solid #e5e7eb;
  overflow: hidden;
}
</style>
